// src/web/components/review-card.jsx

import React from 'react'
import connect from '../../connects/review-card'
import {
  Card,
  CardTitle,
  CardText,
} from 'react-toolbox/lib/card'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import diaryButtonTheme from './themes/diary-form-button.css'
import FontIcon from 'react-toolbox/lib/font_icon'
import { track } from '../../helpers/analytics'

class ReviewCard extends React.Component {
  state ={ isReported: undefined }
  onReport = (report) => {
    if(report === 'good') track('review_report_good', { report })
    if(report === 'bad') track('review_report_bad', { report })
    this.setState({ isReported: true })
  }
  render() {
    const {
      t,
      theme,
      review,
      isFetching,
      isFetchFailed,
      onSendChatGPT,
      onCloseReview,
      onOpenReview,
      isReviewCompleted,
      openSettingsPage,
      isEnable
    } = this.props

    return (
    <Card raised
      className={diaryButtonTheme.reviewCard}
      style={{ marginBottom: 8, marginTop: 8, marginLeft: 8, width: '80%' }}>
      <CardTitle
        avatar={<FontIcon style={{ fontSize: 18, marginRight: 4, color: 'purple' }} key="chatgpt" value='auto_awesome'/>}>
          <div style={{ fontWeight: 'bold' }}>{t('label:AIレビュー')}</div>
      </CardTitle>
      <CardText>{review.length > 0 && <span dangerouslySetInnerHTML={{__html: review.join('')}}/>}
        {isFetching && <span className={diaryButtonTheme.circle}/>}
        {isReviewCompleted && !this.state.isReported && <div style={{ fontWeight: 'bold', fontSize: 14, marginTop: 8, paddingLeft: 16, background: '#f4f4f4', height: 40 }}>
          <IconButton style={{ marginRight: 16 }} icon='thumb_up' onClick={()=> this.onReport('good')} />
          <IconButton style={{ marginRight: 16 }} icon='thumb_down' onClick={()=> this.onReport('bad')} />
          <span>{t('label:この情報は役に立ちましたか')}</span>
        </div>}
        {isReviewCompleted && this.state.isReported && <div style={{ fontWeight: 'bold', fontSize: 14, marginTop: 8, paddingTop: 8,paddingLeft: 16, background: '#f4f4f4', height: 40 }}>
          <div styel={{ marginTop: 8, marginLeft: 16 }}>{t('label:レポートお礼')}</div>
        </div>}
        <div style={{ marginTop: 8 }}>
          {isEnable && <Button
            icon="send"
            disabled={isFetching}
            style={{ width: '150px' }}
            onClick={onSendChatGPT}
            label={t('label:レビューする')} /> 
            || <CardText style={{ fontSize: 12, width: 600, color: 'gray' }}>
                <FontIcon value='info' style={{ fontSize: 14, paddingRight: 8, color: 'gray'}}/>
                <span>{t('label:レビュー機能OFF')}</span>
              </CardText>}
          <Button
            icon="close"
            disabled={isFetching}
            style={{ width: '150px' }}
            onClick={onCloseReview}
            label={t('label:閉じる')} />
        </div>
      </CardText>
      <CardText className={diaryButtonTheme.warningFooter}>
        <div className={diaryButtonTheme.warningContent}>
          <div className={diaryButtonTheme.warningTextGroup}>
            <FontIcon value='warning' style={{ fontSize: 12 }}/>
            <span>{t('label:レビュー注意')}</span>
          </div>
          <div className={diaryButtonTheme.warningActionGroup}>
            <a href={t('label:注意URL')} target="_blank">{t('label:利用規約')}</a>
            <IconButton 
              icon='settings'
              className={diaryButtonTheme.settingsIcon}
              onClick={()=> openSettingsPage()}
            />
          </div>
        </div>
      </CardText>
    </Card>)
  }
}

export default connect(ReviewCard)


// WEBPACK FOOTER //
// ./src/web/components/review-card.jsx